import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotifierWrapService } from '../../services/notifier-wrap.service';
import { isNull } from 'util';
import {Observable, ReplaySubject} from 'rxjs';
import { first } from 'rxjs/operators';
import {Message, Profile} from "../../types/all.type";

@Injectable({
  providedIn: 'root'
})
export class SkypeService {
  public urlApi: any = 'http://127.0.0.1:8000/api';
  public type = 'skype';
  public unreadCount = 0;
  public arProfile: Profile = {} as Profile;
  public setLocalHistory$: ReplaySubject<{
    id, arHistory: Message[]
  }> = new ReplaySubject();

  public getProfile$: ReplaySubject<Profile> = new ReplaySubject();
  constructor(private http: HttpClient, public notifierWrapService: NotifierWrapService) {}
  get isAuth(): boolean {
    return !isNull(localStorage.getItem('auth_skype'));
  }
  chatList() {
    return this.http.get(this.urlApi + '/skype/chats/');
  }
  getHistory(chatId: string | number) {
    return this.http.get(this.urlApi + '/skype/chats/' + chatId);
  }
  auth(login: string, password: string) {
    return this.http.post(this.urlApi + '/skype/auth/', { login, password });
  }

  // Отработка ошибок, для вызовов запросов без подписки
  errorHandling(error: any) {
    switch (error.status) {
      case 401:
        this.notifierWrapService.notify('error', 'Один из аккаунтов был разлогинен, напишите нам, если считаете это ошибкой.');
        // this.logout();
        break;
      case 0:
        this.notifierWrapService.notify('error', 'Сервис временно недоступен, извините за неудобства.');
        break;
      default:
        this.notifierWrapService.notify('error', 'Произошла ошибка.');
    }
  }
  getProfile(initiator = ''): Observable<Profile> {
    return new Observable((observer) => {
      setTimeout(() => {
        observer.next(this.arProfile);
        observer.complete();
      }, 0);
    });
  }
}
